import { ReactElement } from 'react';
import { LabelEnum, InsuranceEnum } from 'app/shared/enums';
import { PropsWithOverridableClasses } from 'app/shared/types/PropsWithOverridableClasses.type';
import { useStyles } from './SelectBox.styles';

export enum SelectBoxMode {
  Icon = 'icon',
  Icon2 = 'icon2',
  CompareIcon = 'compareIcon',
}

interface SelectBoxOwnProps {
  title: LabelEnum | InsuranceEnum | ReactElement | string;
  checkedTitleSuffix?: string;
  checkedTitle?: LabelEnum;
  mode: SelectBoxMode;
  className?: string;
  readonly?: boolean;
  checked: boolean;
  onChange?: (checked: boolean) => void;
  onCheckedClick?: () => void;
  dataCy?: string;
  tabIndex?: number;
  role?: string;
}

export type SelectBoxProps = SelectBoxOwnProps &
  PropsWithOverridableClasses<typeof useStyles>;
